import { styled } from '@mui/material/styles';
import LoaderSpinner from '../../../../../../../elements/LoaderSpinner';

export const StyledWrapper = styled('div')(
  ({ theme }) => `
  div > {
    p {
      padding-bottom: ${theme.DS_spacing(['xxs'])};
    }
    .login-email {
     hyphens: auto;
     word-wrap: break-word;
     overflow: hidden; 
     overflow-wrap: break-word;
    }
  
  
  ${theme.breakpoints.up('lg')} {
     margin-top: ${theme.DS_spacing(['lgx'])};
  }

`,
);

export const StyledCheckIcon = styled('div')(
  ({ theme }) => `
   display: flex;
   align-items: center;
   margin-right:${theme.DS_spacing(['xs'])};
   svg {
    width: 100%;
    height: 100%;
    max-width: 32px;
    fill: none;
     > rect:last-of-type {
        stroke: ${theme.DS_palette.state.success};
     }
   }
`,
);

export const StyledSuccessLogin = styled('div')(
  ({ theme }) => `
    display: flex;
    align-items: center;
    margin-bottom: ${theme.DS_spacing(['xxs'])};
    h3 {

       margin-right: ${theme.DS_spacing(['sm'])};
      }
`,
);

export const StyledDS_ButtonLink = styled('div')(
  () => `
  button {
     text-align: left;
     &:hover {
     box-shadow: none;
     }
  } 
`,
);

export const StyledLoaderSpinner = styled(LoaderSpinner)(
  ({ theme }) => `
  margin: ${theme.DS_spacing(['xxs'])} 0 ${theme.DS_spacing(['md'])} ${theme.DS_spacing(['xl'])} !important;
`,
);
